import styled from 'styled-components';
import IconChevronDownCircleOutline from './IconChevronDownCircleOutline';
var IconChevronLeftCircleOutline = /*#__PURE__*/styled(IconChevronDownCircleOutline).withConfig({
  displayName: "IconChevronLeftCircleOutline",
  componentId: "c11n-8-111-1__sc-gzehhl-0"
})(["transform:rotate(90deg);"]);
export default IconChevronLeftCircleOutline;